// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3DPYH","inputDescription":"styles_inputDescription__1xjIK"};